// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2CMa9","upload":"Small_upload__2AMSB","imageWrap":"Small_imageWrap__UgfpW","removeBtn":"Small_removeBtn__34CwY"};